<template>
  <div class="main">
    <Tabs class="tabs" :tab-list="menuList" title="财务对账" />
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'reconciliation',
  data() {
    return {
      menuList: [
        {
          routerName: 'reconciliation/list',
          text: '对账单记录',
        },
        {
          routerName: 'reconciliation/error',
          text: '差错记录',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.main {
  height: 100%;
  .box_column();
}
</style>
